import React from "react";
import CloseIcon from "../../../../Layout/Icons/CloseIcon";

const DeleteElementButton = ({ onDelete }) => {
  return (
    <div className="button button--delete-image" onClick={onDelete}>
      <CloseIcon />
    </div>
  );
};

export default DeleteElementButton;
